import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "aria-labelledby": "modal-title",
  "aria-modal": "true",
  class: "fixed z-50 inset-0 overflow-y-auto",
  "data-testId": "modal-dialog",
  role: "dialog"
}
const _hoisted_2 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 m-10" }
const _hoisted_3 = { class: "p-4 sm:p-6" }
const _hoisted_4 = {
  class: "mt-3 text-center sm:mt-0 sm:text-left flex justify-between w-full items-start",
  "data-testid": "heading-row"
}
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "flex flex-row" }
const _hoisted_7 = {
  id: "modal-title",
  class: "font-bold text-lg pt-1 text-black"
}
const _hoisted_8 = {
  key: 0,
  class: "mt-1 font-bold"
}
const _hoisted_9 = {
  key: 0,
  class: "px-4 py-4 sm:px-6 sm:flex sm:flex-row-reverse"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cross = _resolveComponent("Cross")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", {
        "aria-hidden": "true",
        class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
      }, null, -1)),
      _createElementVNode("span", {
        "aria-hidden": "true",
        class: _normalizeClass(["hidden sm:inline-block sm:align-middle", { 'sm:h-screen': !_ctx.fullWidth }])
      }, "​", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["inline-table bg-white rounded text-left overflow-scroll shadow-xl transform transition-all align-middle w-full", {
          'max-w-lg my-8': !_ctx.fullWidth && !_ctx.large,
          'max-w-4xl my-8': _ctx.large,
        }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "heading-icon"),
                _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.heading), 1)
              ]),
              (_ctx.subheading)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(_ctx.subheading), 1))
                : _createCommentVNode("", true)
            ]),
            (!_ctx.hideCloseButton)
              ? (_openBlock(), _createBlock(_component_Cross, {
                  key: 0,
                  class: "flex w-5 h-5 cursor-pointer text-primary",
                  "data-testid": "close-button",
                  onClick: _ctx.emitClose
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _renderSlot(_ctx.$slots, "body")
        ]),
        (_ctx.hasActionButtons)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _renderSlot(_ctx.$slots, "action-buttons")
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}